<template>
  <textarea
    :value="currentValue"
    :class="textareaClasses"
    :rows="rows"
    :disabled="disabled"
    :readonly="readonly"
    :placeholder="placeholder"
    v-bind="inputAttrs"
  ></textarea>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'HdFormTextarea',

  inheritAttrs: false,

  props: {
    value: {
      default: null
    },
    modelValue: {
      default: undefined
    },
    rows: {
      type: [Number, String],
      default: 3
    },
    placeholder: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: null,
      validator: (value) => value == null || ['sm', 'lg'].includes(value)
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    state: {
      type: [Boolean, String],
      default: null
    }
  },

  emits: ['input', 'update:modelValue', 'change'],

  computed: {
    currentValue() {
      return this.modelValue !== undefined ? this.modelValue : this.value;
    },

    textareaClasses() {
      const classes = ['form-control', this.$attrs.class].flat().filter(Boolean);

      if (this.size === 'sm') classes.push('form-control-sm');
      if (this.size === 'lg') classes.push('form-control-lg');
      if (this.state === true) classes.push('is-valid');
      if (this.state === false) classes.push('is-invalid');

      return classes;
    },

    // In Vue 3, listeners live in $attrs (as onInput/onChange/...), so a single
    // v-bind forwards both attributes and events. We strip class (handled by
    // textareaClasses) and the emits we manage ourselves, then re-add native
    // handlers: onInput drives v-model, onChange re-emits the element value.
    inputAttrs() {
      const {
        class: _class,
        onInput: _onInput,
        onChange: _onChange,
        'onUpdate:modelValue': _onUpdateModelValue,
        ...attrs
      } = this.$attrs;

      attrs.onInput = (event) => {
        const value = event.target.value;
        this.$emit('input', value);
        this.$emit('update:modelValue', value);
      };

      attrs.onChange = (event) => {
        this.$emit('change', event.target.value);
      };

      return attrs;
    }
  }
});
</script>
